<template>
  <div>
    <h3 class="mb-5">TeamSponsorship</h3>
    <div class="h4 mb-5">
      分為Overview列表頁及DetailPage內頁，你可以在這裏編輯Overview置頂Banner
    </div>

    <!-- items -->
    <PageCollapse v-for="(item, i) in bu.teamsponsorship" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">TeamSponsorship {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- title -->
        <label class="form-item d-flex pt-3">
          <h4 class="w-180px mt-5">Title</h4>
          <div class="flex-grow-1 mt-3">
            <v-text-field
              v-model="item.title"
              outlined
              dense
            ></v-text-field>
          </div>
        </label>
        <!-- img uploader -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Visual</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：999px * 999px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.visual"
              dir="teamsponsorship"></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- add team sponsorship -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加TeamSponsorship</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  props: {
    bu: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        visual: null,
      };
      this.bu.teamsponsorship.push(template);
    },
    deleteItem(item) {
      const index = this.bu.teamsponsorship.map((i) => i.id).indexOf(item.id);
      this.bu.teamsponsorship.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.bu.teamsponsorship.length - 1) {
        this.bu.teamsponsorship.splice(i, 1);
        this.bu.teamsponsorship.unshift(item);
        return;
      }
      // item become next index
      this.bu.teamsponsorship.splice(i, 1);
      this.bu.teamsponsorship.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.bu.teamsponsorship.splice(i, 1);
        this.bu.teamsponsorship.push(item);
        return;
      }
      // item become previous index
      this.bu.teamsponsorship.splice(i, 1);
      this.bu.teamsponsorship.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
